import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../firebase-config';

const LOGO_NAME = 'logo.png';

export function showcaseLogoStoragePath(entryId) {
  return `showcaseLogos/${entryId}/${LOGO_NAME}`;
}

export async function uploadShowcaseLogo(entryId, file) {
  if (!entryId || !file) throw new Error('Logo upload requires an entry id and file.');
  const storagePath = showcaseLogoStoragePath(entryId);
  const storageRef = ref(storage, storagePath);
  const contentType = file.type || 'image/png';
  await uploadBytes(storageRef, file, { contentType });
  const publicUrl = await getDownloadURL(storageRef);
  return { storagePath, logoUrl: publicUrl };
}

export async function deleteShowcaseLogo(storagePath) {
  if (!storagePath) return;
  try {
    await deleteObject(ref(storage, storagePath));
  } catch (err) {
    console.warn('Showcase logo storage delete skipped:', err);
  }
}
